import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.silent = true
import './assets/font/iconfont.css'
import 'amfe-flexible';
// import './assets/js/util.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import BaiduMap from 'vue-baidu-map'
import url from './config/url.js'
Vue.prototype.$url = url
Vue.use(BaiduMap, {
    ak: 'bG2TzgAjSsQP7Td4an1Wv172s4luZigp'
})
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
Vue.prototype.$cookie = VueCookie
import JsEncrypt from "jsencrypt";
Vue.prototype.$jsEncrypt = JsEncrypt
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
// import './assets/css/grey.less'
import Mint from 'mint-ui';
import VueI18n from 'vue-i18n';
import api from './config/api.js'
import zh from './lang/zh.js'
import en from './lang/en.js'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import '../node_modules/social-share.js/dist/js/social-share.min.js'
Vue.use(Share)

Vue.use(VueI18n)
Vue.prototype.$api = api
const i18n = new VueI18n({
    locale: Vue.prototype.$cookie.get('lang') ? Vue.prototype.$cookie.get('lang') : 'zh', //语言标识，默认为中文 , 缓存中存的
    fallbackLocale: 'zh', //当没有英文时  默认语言为中文  //默认语言
    silentFallbackWarn: true,
    messages: {
        zh,
        en
    },
})
import 'mint-ui/lib/style.css'
Vue.use(Mint);
Vue.prototype.cookie = VueCookie
import './util/rem'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
export function checkPrefix(pid) {
    if (pid) {
        pid = pid.replace("CSTR:", "");

        return pid;
    }
    //去空格 转大写

}
Vue.prototype.$checkPrefix = checkPrefix

export function getValue(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) {
            return true;
        }
    }
    return false;
}
Vue.prototype.$getValue = getValue

export function parseFormatNum(number, n) {
    if (n != 0) {
        n = (n > 0 && n <= 20) ? n : 2;
    }
    number = parseFloat((number + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var sub_val = number.split(".")[0].split("").reverse();
    var sub_xs = number.split(".")[1];
    var show_html = "";
    for (var i = 0; i < sub_val.length; i++) {
        show_html += sub_val[i] + ((i + 1) % 3 == 0 && (i + 1) != sub_val.length ? "," : "");
    }
    if (n == 0) {
        return show_html.split("").reverse().join("");
    } else {
        return show_html.split("").reverse().join("") + "." + sub_xs;
    }

}
Vue.prototype.$parseFormatNum = parseFormatNum
export function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    // console.log(r);
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
}
Vue.prototype.$getUrlParam = getUrlParam


// echarts图库
import * as echarts from 'echarts';
import 'echarts-liquidfill'
Vue.prototype.$echarts = echarts;
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import "echarts-wordcloud/dist/echarts-wordcloud"
import "echarts-wordcloud/dist/echarts-wordcloud.min"



import http from "./assets/js/http.js"
Vue.prototype.axios = http;
// 引入qs
import qs from 'qs'
Vue.prototype.$qs = qs;
import less from 'less'
Vue.use(less)
// 图标
Vue.prototype.$validatePhone = (rule, value, callback) => {
    if (!(/^1[345789]\d{9}$/.test(value))) {
        callback('请输入正确的手机号');
    } else {
        callback();
    }
};
function formatNumberAsTenThousand(num) {
    var stringNum = String(num).length

    if (stringNum > 4 || stringNum == 5) {
        const tenThousand = Math.floor((num / 10000) * 10) / 10;
        return tenThousand + '万';
    } else {
        return num
    }

}
Vue.prototype.$formatNumberAsTenThousand = formatNumberAsTenThousand

Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//     console.log(to, from)
//     if (to.path === from.path && JSON.stringify(to.query) === JSON.stringify(from.query)) {
//         // 处理重复导航的逻辑
//         console.warn('NavigationDuplicated: Navigating to current location is not allowed');
//         // 可以选择不进行导航或采取其他措施
//         next(false);
//     } else {
//         next();
//     }
// })
new Vue({
    router,
    i18n,
    //挂到vue上
    ...App
}).$mount('#app')